import fetch from './fetch';
import endpoints from './endpoints';
import parseHttpErrors from './parse-http-errors';
import reactQueryConfig from './react-query-config';

export default {
    fetch,
    endpoints,
    authErrorToastMessageId: 'authError',
    networkErrToastId: 'netError',
    parseHttpErrors,
    reactQueryConfig,
};
